module.exports = __webpack_public_path__ + "img/dead-tree-desert-07.543ec5bc.png";